<template>
  <myhead @next="next" @lookmore="more">{{ $route.query.title || $route.meta.title}}</myhead>
  <div class="ml10 pad5 mt10 mr10">
    <p class="b500 mb10">填写您的个人信息</p>
    <hr class="opacity3">
  </div>
  <div class="myField1">
    <van-field v-model="idcard" label="身份证号" placeholder="请输入您的身份证号" />
    <van-field v-model="realname" label="姓名" placeholder="请输入您的姓名" />
    <van-field v-model="nation" label="民族" placeholder="请输入您的民族" />
    <van-cell title="出生年月" is-link clickable arrow-direction="down" @click="dateAlert = true" :value="birthday||'请选择出生年月'" />
    <van-cell title="手机号" is-link :value="$store.state.loginInfo.mobile" class="noicon"/>
    <!-- <van-field v-model="address" label="住址" type="textarea" rows="3" autosize placeholder="请输入您的住址" /> -->
  </div>
  <van-popup
    v-model:show="dateAlert"
    position="bottom"
    closeable
    class="center vh30 pad25 size16 b500"
  >
    <van-date-picker v-model="birthday"
      title="选择日期" :show-toolbar="false"
      :min-date="minDate"
      :max-date="maxDate"
    />
    <van-button block round type="primary" @click="dateAlert=false">选择日期</van-button>
  </van-popup>
  <div class="fixed l r b pad15">
    <van-button type="primary" round block @click="next">确认</van-button>
  </div>
</template>

<script>
export default {
  name: 'Home',
  data(){
    return {
      minDate: new Date(1940,1,1),
      maxDate: new Date(),
      idcard:'',
      realname:'',
      nation:'',
      birthday:this.$store.state.loginInfo.birthday.split('-'),//[new Date().getFullYear(), (d=>d>9?d:'0'+d)(new Date().getMonth()+1), (d=>d>9?d:'0'+d)(new Date().getDate())],
      address:'',
      dateAlert:false
    }
  },
  methods:{
    more(){
      console.log("更多")
    },
    next(){
      let params = {
        id:this.$store.state.loginInfo.id,
        idcard:this.idcard,
        realname:this.realname,
        nation:this.nation,
        birthday:this.birthday.join('-'),
        // address:this.address
      }
      if(this.$route.path.includes("register")){
        this.ajax.post("users/checkregister",params).then(()=>{
          this.ajax.post("users/register",params);
          this.$store.state.loginStatus = 4;
          this.$store.state.loginInfo = { ...this.$store.state.loginInfo,...params };
          localStorage.setItem("loginInfo",JSON.stringify(this.$store.state.loginInfo));
          this.$router.push({path:'/register/password',query:{title:'注册'}});
        })
      }else{
        this.ajax.post("users/setinfo",{
          typeid:1,
          head_pic:this.head_pic
        }).then(()=>{
          this.$store.state.loginInfo = { ...this.$store.state.loginInfo,...params };
          localStorage.setItem("loginInfo",JSON.stringify(this.$store.state.loginInfo));
          // this.$router.back()
        })
      }
    }
  },
  computed:{},
  mounted(){
    this.idcard = this.$store.state.loginInfo.idcard;
  }
}
</script>

<style>
/* .myField1 .van-field__label,.van-cell__title{color: #999;} */
.van-cell__value{color: #444; }
</style>
